export enum APP_LISTING_TYPE {
    LISTING_INTERNAL_BASIC = 1,
    LISTING_INTERNAL_STANDARD = 2,
    LISTING_INTERNAL_PREMIUM = 3,
    LISTING_EXTERNAL_BASIC = 4,
    LISTING_EXTERNAL_STANDARD = 5,
    LISTING_EXTERNAL_PREMIUM = 6
}